import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import Bowser from 'bowser';
import domReady from '../helpers/dom-ready';

const ANIMATION_DURATION = 0.3333;
// const MENU_HEIGHT = 120;
class Menu {
  static init() {
    return new Menu();
  }

  constructor() {
    this.menuCollapsed = false;
    this.menuCollapsedLocked = false;
    this.toggleButtonLocked = false;
    this.isActive = false;
    this.currentPageYOffset = 0;

    this.container = document.querySelector('.brix-menu');

    if (this.container) {
      const browser = Bowser.getParser(window.navigator.userAgent);
      const platform = Bowser.parse(window.navigator.userAgent);
      if (platform.os.name === 'iOS') {
        if (platform.browser.name !== 'Safari') {
          this.container.classList.add('-no-overflow');
        }
      }
      if (browser.getBrowser().name === 'Safari') {
        this.container.classList.add('-is-safari');
      }

      this.menusContainer = this.container.querySelector('.menu-bar');
      this.scrollContainers = this.container.querySelectorAll('.scroll-container');
      this.mobileSpacer = this.container.querySelector('.mobile-spacer');

      const titleContainer = this.container.querySelector('.title-container');
      if (titleContainer && titleContainer.parentNode) {
        const titleContainerClone = document.createElement('span');
        titleContainerClone.classList.add('title-container-clone');
        titleContainerClone.innerHTML = titleContainer.innerHTML;
        titleContainer.parentNode.appendChild(titleContainerClone);
      }

      if (this.menusContainer) {
        this.searchWrapper = this.menusContainer.querySelector('.search-wrapper');

        if (this.searchWrapper) {
          this.searchButton = this.searchWrapper.querySelector('button');
          this.searchInput = this.searchWrapper.querySelector('input');
          this.searchUrl = this.searchWrapper.dataset.searchUrl;

          this.searchWrapper.addEventListener('click', () => {
            this.searchWrapper.classList.add('-active');
            if (this.searchInput) this.searchInput.focus();
            this.searchInput.setSelectionRange(0, this.searchInput.value.length);
          });

          this.searchWrapper.addEventListener('submit', (event) => {
            event.preventDefault();
            const searchQuery = this.searchInput.value;
            this.search(searchQuery);
          });
        }

        this.toggleButton = this.menusContainer.querySelector('.hamburger');
        const menuContainer = this.menusContainer.querySelector('.menu-container');

        if (this.toggleButton && menuContainer) {
          this.cloneButtons = document.createElement('div');
          this.cloneButtons.classList.add('clone-buttons');

          this.searchButtonClone = document.createElement('span');
          this.searchButtonClone.classList.add('search-button-clone');
          this.cloneButtons.appendChild(this.searchButtonClone);

          this.toggleButtonClone = document.createElement('span');
          this.toggleButtonClone.classList.add('hamburger-clone');
          this.toggleButtonClone.innerHTML = this.toggleButton.innerHTML;
          this.cloneButtons.appendChild(this.toggleButtonClone);

          menuContainer.appendChild(this.cloneButtons);

          this.searchWrapperClone = document.createElement('form');
          this.searchWrapperClone.classList.add('search-wrapper-clone');
          this.searchWrapperClone.innerHTML = this.searchWrapper.innerHTML;
          this.searchWrapperClone.addEventListener('submit', (event) => {
            event.preventDefault();
            const searchQuery = this.searchWrapperClone.querySelector('input').value;
            this.search(searchQuery);
          });

          this.container.appendChild(this.searchWrapperClone);
        }

        if (this.toggleButton) {
          this.toggleButton.addEventListener('click', () => {
            // if (this.container.classList.contains('-collapsed')) {
            //   this.container.classList.remove('-collapsed');
            // }

            this.onToggleSubMenu();
          });
        }

        if (this.toggleButtonClone) {
          this.toggleButtonClone.addEventListener('click', () => {
            // if (this.container.classList.contains('-collapsed')) {
            //   this.container.classList.remove('-collapsed');
            // }

            this.onToggleSubMenu();
          });
        }

        if (this.searchButtonClone) {
          this.searchButtonClone.addEventListener('click', () => {
            if (!this.searchWrapperClone.classList.contains('-active')) {
              this.searchWrapperClone.classList.add('-active');
              this.searchButtonClone.classList.add('-active');
              this.searchWrapperClone.querySelector('input').focus();
              if (this.container) {
                this.container.classList.add('-search-open');
              }
            } else {
              this.searchButtonClone.classList.remove('-active');
              this.searchWrapperClone.classList.remove('-active');
              if (this.container) {
                this.container.classList.remove('-search-open');
              }
            }
          });
        }

        // const self = this;
        // requestAnimationFrame(function onAnimationFrame() {
        //   self.onAnimationFrame();
        //   requestAnimationFrame(onAnimationFrame);
        // });

        window.addEventListener('scroll', () => {
          setTimeout(() => {
            this.onAnimationFrame();
          }, 300);
        });

        window.addEventListener('resize', () => this.onResize());
      }
    }

    this.detectOutsideClick();
  }

  detectOutsideClick() {
    document.addEventListener('click', (event) => {
      if (this.searchWrapperClone.classList.contains('-active')) {
        if (
          event.target !== this.searchWrapperClone
          && event.target !== this.searchButtonClone
          && event.target !== this.searchWrapperClone.querySelector('button')
          && event.target !== this.searchWrapperClone.querySelector('input')
        ) {
          this.searchWrapperClone.classList.remove('-active');
          this.searchButtonClone.classList.remove('-active');
        }
      }

      if (this.searchWrapper.classList.contains('-active')) {
        if (
          event.target !== this.searchWrapper
          && event.target !== this.searchButton
          && event.target !== this.searchWrapper.querySelector('button')
          && event.target !== this.searchWrapper.querySelector('input')
        ) {
          this.searchWrapper.classList.remove('-active');
        }
      }
    });
  }

  search(query) {
    window.location.href = `${this.searchUrl}?search=${query}`;
  }

  onAnimationFrame() {
    if (this.menuCollapsedLocked) {
      return;
    }

    const pageYOffset = window.pageYOffset
            || document.documentElement.scrollTop
            || document.body.scrollTop || 0;

    // const direction = pageYOffset - this.previousPageYOffset;
    // this.previousPageYOffset = pageYOffset;
    if (pageYOffset > 200) {
      this.container.classList.add('-collapsed');
      this.menuCollapsed = true;
      this.menuCollapsedLocked = true;

      setTimeout(() => {
        this.previousPageYOffset = window.pageYOffset
                || document.documentElement.scrollTop
                || document.body.scrollTop || 0;
        this.menuCollapsedLocked = false;
      }, ANIMATION_DURATION * 1000);
    } else {
      const browser = Bowser.getParser(window.navigator.userAgent);
      if (browser.getBrowser().name === 'Safari' && (window.innerHeight + window.scrollY) > (document.body.offsetHeight - 100)) return;

      this.container.classList.remove('-collapsed');
      this.menuCollapsed = false;
      this.menuCollapsedLocked = true;

      setTimeout(() => {
        this.previousPageYOffset = window.pageYOffset
                || document.documentElement.scrollTop
                || document.body.scrollTop || 0;
        this.menuCollapsedLocked = false;
      }, ANIMATION_DURATION * 1000);
    }
  }

  onResize() {
    this.container.classList.add('-no-transition');
    setTimeout(() => {
      this.container.classList.remove('-no-transition');
    }, 0);

    const subMenu1 = this.container.querySelectorAll('.sub-menu-1 .menu-item');
    const subMenu2 = this.container.querySelectorAll('.sub-menu-2 .menu-item');
    if (window.innerWidth > 900) {
      [...subMenu1].forEach((menuItem) => {
        // eslint-disable-next-line no-param-reassign
        menuItem.style.height = `calc(100vh / ${subMenu1.length} - (120px / ${subMenu1.length})`;
      });
      [...subMenu2].forEach((menuItem) => {
        // eslint-disable-next-line no-param-reassign
        menuItem.style.height = `calc(100vh / ${subMenu2.length} - (120px / ${subMenu2.length})`;
      });
    } else {
      [...subMenu1].forEach((menuItem) => {
        // eslint-disable-next-line no-param-reassign
        menuItem.style.height = 'auto';
      });
      [...subMenu2].forEach((menuItem) => {
        // eslint-disable-next-line no-param-reassign
        menuItem.style.height = 'auto';
      });
    }
  }

  onToggleSubMenu() {
    if (this.toggleButtonLocked) { return; }
    this.toggleButtonLocked = true;

    if (this.container.classList.contains('-active')) {
      this.container.classList.remove('-active');
      this.container.classList.add('-animating');

      this.container.querySelector('.title-container').style.height = null;

      if (this.mobileSpacer.classList.contains('-hidden')) {
        this.mobileSpacer.classList.add('-hidden');
      }

      this.toggleButton.innerHTML = this.toggleButton.dataset.openLabel;

      document.body.classList.remove('-fixed');
      this.isActive = false;
      const openMenuWrapper = document.querySelector('.scroll-container.flex-container');
      enableBodyScroll(openMenuWrapper);

      window.scrollTo(0, this.currentPageYOffset);

      setTimeout(() => {
        this.toggleButtonLocked = false;
        this.container.classList.remove('-animating');
        if (this.container.classList.contains('transparent-white') || this.container.classList.contains('transparent-black')) {
          this.container.classList.remove('solid');
        }
      }, Math.ceil(ANIMATION_DURATION * 1000));
    } else {
      if (this.scrollContainers) {
        [...this.scrollContainers].forEach((scrollContainer) => {
          // eslint-disable-next-line no-param-reassign
          scrollContainer.scrollTop = 0;
        });
      }

      if (window.innerWidth > 900) {
        const titleContainer = this.container.querySelector('.title-container');
        titleContainer.style.height = `${window.innerHeight}px`;

        const subMenu1 = this.container.querySelectorAll('.sub-menu-1 .menu-item');
        const subMenu2 = this.container.querySelectorAll('.sub-menu-2 .menu-item');

        [...subMenu1].forEach((menuItem) => {
          // eslint-disable-next-line no-param-reassign
          menuItem.style.height = `calc(100vh / ${subMenu1.length} - (120px / ${subMenu1.length})`;
        });
        [...subMenu2].forEach((menuItem) => {
          // eslint-disable-next-line no-param-reassign
          menuItem.style.height = `calc(100vh / ${subMenu2.length} - (120px / ${subMenu2.length})`;
        });

        window.addEventListener('resize', () => {
          if (this.container.classList.contains('-active')) {
            titleContainer.style.height = `${window.innerHeight}px`;
          }
        });
      }

      if (this.isMobile()) {
        this.mobileSpacer.classList.remove('-hidden');

        if (window.innerWidth > 768) {
          this.mobileSpacer.classList.add('-small');
        }
      }

      this.container.classList.add('-active');
      this.container.classList.add('-animating');
      if (this.container.classList.contains('transparent-white') || this.container.classList.contains('transparent-black')) {
        this.container.classList.add('solid');
      }

      setTimeout(() => {
        this.currentPageYOffset = window.pageYOffset
        || document.documentElement.scrollTop
        || document.body.scrollTop || 0;

        this.isActive = true;
        const openMenuWrapper = document.querySelector('.scroll-container.flex-container');
        disableBodyScroll(openMenuWrapper);
        document.body.classList.add('-fixed');
        document.body.style.top = `${-this.currentPageYOffset}px`;

        this.toggleButtonLocked = false;
        this.container.classList.remove('-animating');
      }, Math.ceil(ANIMATION_DURATION * 1000));
    }
  }

  isMobile() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) { return 'Windows Phone'; }
    if (/android/i.test(userAgent)) { return 'Android'; }
    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) { return 'iOS'; }
    return false;
  }
}

domReady(() => {
  Menu.init();
});
